import { PaymentDetails } from 'common/services/pay-service';

import { AstroCustomHeaders } from 'common/helpers/cookiesHandler';
import { Country } from 'common/types/global';

export interface RequestError {
  status: number;
  description: string;
  error: string;
  code?: number;
  link?: string;
  required_fields?: string[];
}
export enum BackFromProfile {
  WALLET = 'WALLET',
  CARD = 'CARD',
  PM = 'PM',
  SUBSCRIPTION = 'SUBSCRIPTION',
  REVERSE = 'REVERSE',
  REVERSE_APC = 'REVERSE_APC',
  ANONYMOUS_CARD = 'ANONYMOUS_CARD',
  AUTH = 'AUTHENTICATION',
}
export interface GlobalState {
  error?: RequestError;
  countries: Country[];
  country: Country;
  token: string;
  requiredFields: string[];
  backFromProfile?: BackFromProfile;
  isSdk: boolean;
  mobileSdk: boolean;
  payment?: PaymentDetails;
  cookies?: Record<AstroCustomHeaders, string>;
  whiteLabel?: boolean;
}
